module.exports = __webpack_public_path__ + "static/media/arrows-resize-h.add426cd.svg";